import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch } from "react-redux";

import OTPHeader from "./OTPHeader";
import OTPInputBoxes from "./OTPInputBoxes";
import OTPSubmitButton from "./OTPSubmitButton";
import OTPBottomLinks from "./OTPBottomLinks";
import ResendOTPButton from "./ResendOTPButton";

import api from "../../../services/api";
import { loginSuccess } from "../../../features/auth/authSlice";
import { setUser } from "../../../features/user/userSlice";

const VerifyOTPPage = () => {
  const [otpCode, setOtpCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otpCode.length !== 4) {
      toast.warn("Please enter 4-digit OTP");
      return;
    }

    setLoading(true);

    const payload = {
      formData: {
        mobile: localStorage.getItem("mobile"),
        deviceId: localStorage.getItem("deviceId"),
        otp: otpCode,
        requestId: "532754327",
        haveNotch: false,
        deviceCountry: "India",
      },
    };

    try {
      const res = await api.post("/v1/otp/verifyOTP", payload);

      if (res.data.response.responseCode === "200") {
        const { accessToken, refreshToken } = res.data.data;

        // ✅ Store auth in Redux
        dispatch(
          loginSuccess({
            accessToken,
            refreshToken,
          })
        );

        // ✅ Fetch user
        const userRes = await api.get("/v1/user/my");
        const user = userRes.data.data;

        dispatch(setUser(user));

        toast.success("OTP Verified Successfully!");

        if (!user.name || user.name.trim() === "") {
          navigate("/username");
        } else {
          navigate("/");
        }
      } else {
        toast.error(
          res.data.response.responseMessage || "Invalid OTP"
        );
      }
    } catch (err) {
      console.error(err);
      toast.error("OTP verification failed. Try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section>
      <div className="login_section b_space_top">
        <div className="container">
          <OTPHeader />
          <div className="login_block text-center pt-lg-2">
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-4 d-flex justify-content-center">
                <OTPInputBoxes onComplete={setOtpCode} />
              </div>

              <OTPSubmitButton loading={loading} isValid={otpCode.length === 4} />
              <ResendOTPButton/>
            </form>

            <OTPBottomLinks />
            <ToastContainer/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifyOTPPage;